export default __webpack_public_path__ + "static/media/csv.c5ae912e.svg";